import { Injectable } from '@angular/core';
import { AbstractEntityService } from '@app/shared/abstract/abstract-entity.service';
import { HttpClient } from '@angular/common/http';
import { UserModel } from './user.model';

@Injectable({
  providedIn: 'root',
})
export class UserService extends AbstractEntityService<UserModel> {
  constructor(http: HttpClient) {
    super('/api/users', http);
  }
}
